import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery } from '@apollo/react-hooks'
import {
  WithdrawalsChartByClientId_clientCharts,
  WithdrawalsChartByClientId_clientChartsVariables
} from '../../../_generated/WithdrawalsChartByClientId_clientCharts'
import { Precision } from '../../../_generated/globalTypes'

export const QUERY = gql`
query WithdrawalsChartByClientId_clientCharts($id: ID!, $precision: Precision!) {
  charts {
    byClientId(id: $id) {
      id: clientId
      withdrawals(precision: $precision) {
        begin
        valuesCount
        values
        labels
        currency
      }
    }
  }
}`

export type Q = WithdrawalsChartByClientId_clientCharts
export type V = WithdrawalsChartByClientId_clientChartsVariables
export type R = Q['charts']['byClientId']['withdrawals']

export const parseData = (data: Q): R => {
  return get(data, p=> p.charts.byClientId.withdrawals)
}

export function Use(clientId: string) {
  const query = useQuery<Q, V>(
      QUERY,
      {
          variables: {
              id: clientId,
              precision: Precision.MONTH
          }
      }
  )

  const { loading, error, data } = query

  return { loading, error, data: parseData(data) }
}
